import React from 'react';
import BoxInfo from '../BoxInfo/BoxInfo';

const BoxStepInfo = (props) => {
  return <BoxInfo>{props.texto}</BoxInfo>;
};
export default BoxStepInfo;
